const createTemplate = (options = {}) => {
  return (`
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true" data-template="lightbox">
    <div class="pswp__bg"></div>

    <div class="pswp__scroll-wrap">

      <div class="pswp__container">
        <!-- don't modify these 3 pswp__item elements, data is added later on -->
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
        <div class="pswp__item"></div>
      </div>

      <div class="pswp__ui pswp__ui--hidden">

        <div class="pswp__top-bar">

          <div class="pswp__primary-actions hidden">
          </div>

          ${getIconActions(options)}

          <div class="pswp__preloader">
            <div class="pswp__preloader__icn">
              <div class="pswp__preloader__cut">
                <div class="pswp__preloader__donut"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
          <div class="pswp__share-tooltip"></div>
        </div>

        <button class="pswp__button pswp__button--arrow--left icon icon-chevron-left-o"title="${__('Anterior')}">
        </button>

        <button class="pswp__button pswp__button--arrow--right icon icon-chevron-right-o" title = "${__('Siguiente')}">
        </button>

        <div class="pswp__counter"></div>
        <div class="pswp__caption">
          <div class="pswp__caption__center"></div>
        </div>

      </div>
    </div>
  </div>
  `);
};

const getIconActions = (options) => {
  const {
    topBar,
  } = options;

  const actions = [...topBar.defaultActions, ...topBar.actions];

  return actions.map(crateActionButton);
};


const crateActionButton = ({
  className,
  label,
}) => {
  return `<button class="pswp__button pswp__button--action ${className}" title="${label}"></button>`;
};

export default createTemplate;
